// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 991 ? "resolve" : chunkId) + "." + {"98":"935a37db","357":"2d3cb23b","532":"c51ac878","991":"99af1535"}[chunkId] + ".js";
};